/* KymiRing Theme JS */
document.addEventListener('DOMContentLoaded', function() {

  /* ── Mobile menu ── */
  const menuBtn = document.getElementById('mob-menu-btn');
  const mobileMenu = document.getElementById('mob-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      const isOpen = mobileMenu.classList.toggle('open');
      menuBtn.classList.toggle('is-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        menuBtn.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Variant price update ── */
  const variantSelect = document.querySelector('.variant-select');
  const priceEl = document.querySelector('.product-price .amount');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function() {
      const selected = this.options[this.selectedIndex];
      const price = selected.dataset.price;
      if (price) priceEl.textContent = '€' + (parseInt(price) / 100).toFixed(2);
    });
  }

  /* ── Cart quantity buttons ── */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const input = this.parentNode.querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'plus') val++;
      if (this.dataset.action === 'minus' && val > 1) val--;
      input.value = val;
    });
  });

  /* ── Nav scroll style ── */
  const nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.background = window.scrollY > 60
        ? 'rgba(0,0,0,.96)'
        : 'rgba(0,0,0,.88)';
    }, { passive: true });
  }

});